import { asyncComponent } from "../../../helpers/asyncComponent";

export const LegacyIllustrations = {
  Stop: asyncComponent({
    module: () => import("./Stop"),
    component: (module) => module.Stop,
  }),
  Unplugged: asyncComponent({
    module: () => import("./Unplugged"),
    component: (module) => module.Unplugged,
  }),
};
